"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelMenuItemView = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../utils");
var label_button_item_main_styled_1 = require("../atoms/label-button-item-main-styled");
var label_button_item_text_styled_1 = require("../atoms/label-button-item-text-styled");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 3px 7px;\n  width: 100%;\n"], ["\n  padding: 3px 7px;\n  width: 100%;\n"])));
var LabelButtonItemMainStyledThin = (0, styled_components_1.default)(label_button_item_main_styled_1.LabelButtonItemMainStyled)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  height: 30px;\n"], ["\n  height: 30px;\n"])));
exports.LabelMenuItemView = (0, react_1.memo)(function (_a) {
    var onClick = _a.onClick, label = _a.label, labelSaturation = _a.labelSaturation, labelLightness = _a.labelLightness;
    var hsl = (0, react_1.useMemo)(function () { return [label.hue, labelSaturation, labelLightness]; }, [label, labelSaturation, labelLightness]);
    var labelButtonStyle = (0, react_1.useMemo)(function () { return ({
        backgroundColor: (0, utils_1.hslToStr)(hsl),
        color: (0, utils_1.higherContrastTextColorHsl)(hsl)
    }); }, [hsl]);
    var onClickHandler = (0, react_1.useCallback)(function () {
        onClick(label.id);
    }, [onClick, label.id]);
    return (react_1.default.createElement(Root, null,
        react_1.default.createElement(LabelButtonItemMainStyledThin, { style: labelButtonStyle, onClick: onClickHandler },
            react_1.default.createElement(label_button_item_text_styled_1.LabelButtonText, null, label.name))));
});
exports.LabelMenuItemView.displayName = 'LabelMenuItem';
var templateObject_1, templateObject_2;
